const initialState = {
  params: {
    courseId: null,
    activitiesId: null,
    activitiesDate: null,
    activitiesDetailId: null,
  },
  activities: null,
  activitiesDetail: null,
  courseOptions: null,
  activitiesOptions: null,
  course: null,
  courses: null,
  activitiesList: null,
  activitiesId: null,
  activitiesDate: null,
  activitiesDateList: null,
  checkInActivities: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "API_ACTIVITIES_GET_ACTIVITIES":
      return {
        ...state,
        activities: action.data.activities,
        activitiesDetail: action.data.activitiesDetail,
        checkInActivities: action.data.checkInActivities,
      };
    case "API_ACTIVITIES_GET_EDIT_ACTIVITIES":
      return {
        ...state,
        courseOptions: action.data.courseOptions,
        activitiesOptions: action.data.activitiesOptions,
      };
    case "API_ACTIVITIES_SAVE_ACTIVITIES_DETAIL":
      return {
        ...state,
        activities: action.data.activities,
        activitiesDetail: action.data.activitiesDetail,
      };
    case "API_ACTIVITIES_DELETE_ACTIVITIES_DETAIL":
      return {
        ...state,
      };
    case "API_ACTIVITIES_GET_ACTIVITIES_COURSE":
      return {
        ...state,
        courses: action.data.courses,
      };
    case "API_ACTIVITIES_SAVE_ACTIVITIES_COURSE":
      return {
        ...state,
        courses: action.data.courses,
      };
    case "API_ACTIVITIES_DELETE_ACTIVITIES_COURSE":
      return {
        ...state,
        courses: action.data.courses,
      };
    case "API_ACTIVITIES_GET_ACTIVITIES_TRIP":
      return {
        ...state,
        course: action.data.course,
        activitiesList: action.data.activitiesList,
      };
    case "API_ACTIVITIES_SAVE_ACTIVITIES_TRIP":
      return {
        ...state,
        activitiesList: action.data.activitiesList,
      };
    case "API_ACTIVITIES_DELETE_ACTIVITIES_TRIP":
      return {
        ...state,
        activitiesList: action.data.activitiesList,
      };
    case "API_ACTIVITIES_GET_ACTIVITIES_LIST":
      return {
        ...state,
        activitiesId: action.activitiesId,
        activitiesBeans: action.data.activitiesBeans,
      };

    case "API_ACTIVITIES_GET_ACTIVITIES_DATE":
      return {
        ...state,
        activitiesId: action.activitiesId,
        activitiesDateList: action.data.activitiesDateList,
      };
    case "API_ACTIVITIES_SET_PARAM":
      return {
        ...state,
        course: action.course ? action.course : state.course,
        activitiesDate: action.activitiesDate
          ? action.activitiesDate
          : state.activitiesDate,
        activitiesBean: action.activitiesBean
          ? action.activitiesBean
          : state.activitiesBean,
        params: action.params,
      };
    default:
      return state;
  }
};
export default reducer;
